import {
    OUTWARD_GET_CATEGORY_ATTRIBUTE_FAILURE,
    OUTWARD_GET_CATEGORY_ATTRIBUTE_REQUEST,
    OUTWARD_GET_CATEGORY_ATTRIBUTE_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
    outWardCategoryAttribute: [],
    loading: false,
    error: null,
};

const ourWardCategoryAttributeReducer = (state = initialState, action) => {
    switch (action.type) {
        case OUTWARD_GET_CATEGORY_ATTRIBUTE_REQUEST:
            return { ...state, loading: true, error: null };
        case OUTWARD_GET_CATEGORY_ATTRIBUTE_SUCCESS:
            return { ...state, loading: false, outWardCategoryAttribute: action.payload };
        case OUTWARD_GET_CATEGORY_ATTRIBUTE_FAILURE:
            return { ...state, loading: false, error: action.payload,outWardCategoryAttribute:[] };
        default:
            return state;
    }
};

export default ourWardCategoryAttributeReducer;
